<template>
    <el-dialog v-if="elderDialogVisible" :title="name" custom-class="vpop-dialog v-Organization-dialog"
        :visible.sync="elderDialogVisible" append-to-body @close="hidePop">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="体重" name="体重">
                <div class="charts-content">
                    <lines v-if="activeName == '体重'" :lineDatas="TZ" chartNmaes="lineTZ"></lines> 
                </div>
            </el-tab-pane>
            <el-tab-pane label="体温" name="体温">
                <div class="charts-content">
                    <lines v-if="activeName == '体温'" :lineDatas="TW" chartNmaes="lineTW"></lines>
                </div>
            </el-tab-pane>
            <el-tab-pane label="血压" name="血压">
                <div class="charts-content">
                    <doubleLine v-if="activeName == '血压'" :lineDatas="XY" chartNmaes="lineXY"></doubleLine>
                </div>
            </el-tab-pane>
            <el-tab-pane label="餐前血糖" name="餐前血糖">
                <div class="charts-content">
                    <lines v-if="activeName == '餐前血糖'" :lineDatas="CQXT" chartNmaes="lineCQXT"></lines>
                </div>
            </el-tab-pane>
            <el-tab-pane label="餐后血糖" name="餐后血糖">
                <div class="charts-content">
                    <lines v-if="activeName == '餐后血糖'" :lineDatas="CHXT" chartNmaes="lineCHXT"></lines>
                </div>
            </el-tab-pane>
            <el-tab-pane label="血氧" name="血氧">
                <div class="charts-content">
                    <lines v-if="activeName == '血氧'" :lineDatas="XYG" chartNmaes="lineXYG"></lines>
                </div>
            </el-tab-pane>
            <el-tab-pane label="心率" name="心率">
                <div class="charts-content">
                    <lines v-if="activeName == '心率'" :lineDatas="XL" chartNmaes="lineXL"></lines>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</template>

<script>
import PubSub from 'pubsub-js'
import { mapGetters } from 'vuex'
import lines from './line.vue'
import doubleLine from './doubleLine.vue'
export default {
    name: 'ElderHealth',
    computed: {
        ...mapGetters(['cid']),
    },
    components: {
        lines,
        doubleLine
    },
    data() {
        return {
            totalData: {},
            elderDialogVisible: false,
            name: '健康信息',
            activeName: '体重',
            TZ: [],
            TW: [],
            XY: [],
            CQXT: [],
            XYG: [],
            XL: [],
            CHXT: [],
        }
    },
    watch: {
        totalData(newData, oldData) {
            if (newData != oldData) {
                newData.BoList = newData.BoList.reverse()
                this.XYG = newData.BoList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordHTime),
                        house: item.SignRecordHValue
                    }
                })
                newData.TempList = newData.TempList.reverse()
                this.TW = newData.TempList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordDTime),
                        house: item.SignRecordDValue
                    }
                })
                newData.HeightWeightList = newData.HeightWeightList.reverse()
                this.TZ = newData.HeightWeightList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordATime),
                        house: item.SignRecordAbValue
                    }
                })
                newData.HrList = newData.HrList.reverse()
                this.XL = newData.HrList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordITime),
                        house: item.SignRecordIValue
                    }
                })
                newData.AfterMealFbgList = newData.AfterMealFbgList.reverse()
                this.CHXT = newData.AfterMealFbgList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordFTime),
                        house: item.SignRecordFValue
                    }
                })
                newData.BeforeMealFbgList = newData.BeforeMealFbgList.reverse()
                this.CQXT = newData.BeforeMealFbgList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordFTime),
                        house: item.SignRecordFValue
                    }
                })
                newData.BpList = newData.BpList.reverse()
                this.XY = newData.BpList.map(item => {
                    return {
                        month: this.getTime(item.SignRecordETime),
                        house: item.SignRecordEaValue,
                        govern: item.SignRecordEbValue,
                    }
                })
                PubSub.publish('TZ', {
                    keyWord: 'TZ',
                    value: this.TZ
                })
            }
        }
    },
    mounted() {
        PubSub.subscribe('health', (msg, data) => {
            this.getYNCheckElderInfoSignRecord(data.id)
            this.elderDialogVisible = data.visible
        })
    },
    methods: {
        getTime(data) {
            if (data) {
                return data.split("T")[0] + "\n" + data.split("T")[1]
            }
        },
        hidePop() {
            this.activeName = '体重';
            this.TZ = []
            this.TW = []
            this.XY = []
            this.CQXT = []
            this.CHXT = []
            this.XYG = []
            this.XL = []
        },
        handleClick(data) {
            let name = data.name
            console.log(name);
            if (name == '血氧') {
                PubSub.publish('XYG', {
                    keyWord: 'XYG',
                    value: this.XYG
                })
            } else if (name == '体重') {
                PubSub.publish('TZ', {
                    keyWord: 'TZ',
                    value: this.TZ
                })
            } else if (name == '体温') {
                PubSub.publish('TW', {
                    keyWord: 'TW',
                    value: this.TW
                })
            } else if (name == '餐前血糖') {
                PubSub.publish('CQXT', {
                    keyWord: 'CQXT',
                    value: this.CQXT
                })
            } else if (name == '餐后血糖') {
                PubSub.publish('CHXT', {
                    keyWord: 'CHXT',
                    value: this.CHXT
                })
            } else if (name == '心率') {
                PubSub.publish('XL', {
                    keyWord: 'XL',
                    value: this.XL
                })
            }else if (name == '血压') {
                PubSub.publish('XYs', {
                    keyWord: 'XY',
                    value: this.XY
                })
            }
        },
        getYNCheckElderInfoSignRecord(id) {
            this.$api
                .getYNCheckElderInfoSignRecord(id)
                .then((data) => {
                    // console.log("-------------------------->ElderDetail");
                    // console.log(data)
                    this.totalData = data
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.charts-content {
    width: 100%;
    height: 400px;
}
</style>